import { css } from '@stitches/core';
import { generateClassNames } from '@supabase/auth-ui-shared';
var dividerDefaultStyles = css({
    background: '$dividerBackground',
    display: 'block',
    margin: '16px 0',
    height: '1px',
    width: '100%'
});
var Divider = function (props) {
    var _a, _b;
    var classNames = generateClassNames('divider', dividerDefaultStyles(), props.appearance);
    return (<div {...props} style={(_b = (_a = props.appearance) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.divider} class={classNames.join(' ')}/>);
};
export { Divider };
